import { connect } from 'react-redux';
import { call, put, takeEvery, takeLatest, all } from 'redux-saga/effects';
import { UserAuthSaga } from './userAuthSaga'

export default function* MainSaga() {
    try {
        yield all([
            ...UserAuthSaga])
    }
    catch (error) {
    }
}


// WEBPACK FOOTER //
// ./src/redux/redux-saga/mainSaga.js